var copyButton = document.getElementById('copyButton');

if (copyButton) {
    copyButton.addEventListener('click', function () {
        var url = window.location.href;
        var tempInput = document.createElement('input');
        tempInput.value = url;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        // Show copy-url message for 5 sec
        var copyMessage = document.getElementById('copyMessage');
        copyMessage.style.display = 'block';
        setTimeout(function () {
            copyMessage.style.display = 'none';
        }, 5000);
    });
}
